import { render } from "./RemoteSign.vue?vue&type=template&id=746cd212"
import script from "./RemoteSign.vue?vue&type=script&lang=ts"
export * from "./RemoteSign.vue?vue&type=script&lang=ts"

import "./RemoteSign.vue?vue&type=style&index=0&id=746cd212&lang=css"
script.render = render

export default script